import LegalLayout from '../components/LegalLayout'

export default function AvisoLegal() {
  return (
    <LegalLayout
      title="Aviso legal"
      description="Información legal de PresenzIA conforme a la LSSI-CE: titular del sitio web, datos de contacto, propiedad intelectual y condiciones generales de uso."
      lastUpdate="3 de mayo de 2026"
      canonicalPath="/aviso-legal"
    >
      <p>
        En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la
        Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se proporciona la siguiente
        información:
      </p>

      <h2>1. Titular del sitio web</h2>
      <ul>
        <li><strong>Denominación:</strong> 1MB Software (en adelante, "PresenzIA").</li>
        <li><strong>Dominio:</strong> https://presenzia.app</li>
        <li><strong>Email de contacto:</strong> info@presenzia.app</li>
        <li><strong>Email de privacidad/DPO:</strong> privacidad@presenzia.app</li>
      </ul>
      <p>
        Para consultar el resto de datos de identificación fiscal y registrales, escríbenos a
        info@presenzia.app y te los facilitaremos.
      </p>

      <h2>2. Objeto</h2>
      <p>
        PresenzIA es un servicio SaaS (Software as a Service) de control horario y registro de
        jornada laboral dirigido a pymes, micropymes y asesorías en España. Permite a las
        empresas cumplir con la obligación de registro horario establecida en el Real Decreto-ley
        8/2019 y normativa concordante.
      </p>

      <h2>3. Condiciones de uso</h2>
      <p>
        El acceso y uso del sitio implica la aceptación íntegra de este aviso legal. Si no
        estás de acuerdo, abstente de utilizar el sitio.
      </p>
      <p>El usuario se compromete a:</p>
      <ul>
        <li>Hacer un uso adecuado y lícito del sitio web y de sus contenidos.</li>
        <li>No realizar actividades publicitarias, promocionales o de explotación comercial sin autorización.</li>
        <li>No introducir virus, código malicioso o realizar ataques que comprometan la seguridad.</li>
        <li>No suplantar la identidad de otros usuarios ni intentar acceder a cuentas ajenas.</li>
        <li>Mantener la confidencialidad de sus credenciales de acceso.</li>
      </ul>

      <h2>4. Propiedad intelectual e industrial</h2>
      <p>
        Todos los contenidos del sitio (textos, imágenes, diseño gráfico, código fuente, logos,
        marca PresenzIA) son propiedad de 1MB Software o de terceros que han autorizado su uso.
        Quedan reservados todos los derechos.
      </p>
      <p>
        Queda prohibida la reproducción, distribución, comunicación pública o transformación
        sin autorización expresa por escrito.
      </p>

      <h2>5. Exclusión de garantías y responsabilidad</h2>
      <p>
        PresenzIA hace su mayor esfuerzo por garantizar la disponibilidad y exactitud del
        servicio, pero no puede garantizar de forma absoluta la inexistencia de interrupciones
        o errores. PresenzIA no será responsable de:
      </p>
      <ul>
        <li>Interrupciones temporales por mantenimiento o fallos de terceros (proveedores de hosting, conexión a internet del usuario, etc.).</li>
        <li>Daños derivados del uso inadecuado del servicio.</li>
        <li>Contenido aportado por los usuarios o por sus empleados a través de la plataforma.</li>
      </ul>

      <h2>6. Enlaces a terceros</h2>
      <p>
        El sitio puede contener enlaces a otros sitios web. PresenzIA no es responsable del
        contenido ni de las prácticas de privacidad de dichos sitios.
      </p>

      <h2>7. Modificación del aviso legal</h2>
      <p>
        PresenzIA se reserva el derecho a modificar este aviso legal en cualquier momento.
        Las modificaciones serán publicadas en esta misma página.
      </p>

      <h2>8. Legislación aplicable y jurisdicción</h2>
      <p>
        Este aviso legal se rige por la legislación española. Para cualquier controversia,
        las partes se someten a los tribunales y juzgados que correspondan según la legislación
        vigente, con renuncia a cualquier otro fuero que pudiera corresponderles.
      </p>
      <p>
        Para consumidores y usuarios, será competente el juzgado del domicilio del consumidor
        conforme al artículo 90.2 del Real Decreto Legislativo 1/2007.
      </p>
    </LegalLayout>
  )
}
